import APIKeyForm from "../APIKeyForm";

export const APIKeyAdd = (): JSX.Element => {
  return <APIKeyForm />;
};

export default APIKeyAdd;
